module.exports = __webpack_public_path__ + "img/iconfinder-icon-location.46507807.svg";